<template>
  <div class="home">
    <!-- <div class="feedback"> 
      <p>
        本日收到用户反馈
        <span class="red">{{ feedback.todayCount }}</span> 条/待处理反馈
        <span class="red">{{ feedback.untreated }}</span> 条
      </p>
      <router-link
        :to="{
          path: '/feedback',
        }"
      >
        用户反馈>>>
      </router-link>
    </div> -->
    <div class="content" style="margin-top: 0">
      <div class="title">
        <div
          class="left"
          style="font-weight: 500; font-family: pfc, sans-serif"
        >
          平台数据概览
        </div>
        <div class="right">
          <el-date-picker
            v-model="value1"
            size="mini"
            type="date"
            :value-format="searchValFormat"
            :clearable="false"
            :picker-options="pickerOptions"
            placeholder="选择日期"
            style="background-color: #f2f3f5"
            @change="requestUserImportantMetricsfn"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="detail">
        <div class="item" style="background-color: #e8fffb">
          <div class="detail-title">总用户</div>
          <div class="detail-content">
            <div class="content-left">
              <div class="detail-num">{{ totalUserInfo.Num }}</div>
              <div class="detail-text">
                <span style="color: #f53f3f" v-if="totalUserInfo.AddNum > 0"
                  >+{{ totalUserInfo.AddNum }}
                </span>
                <span style="color: #00b42a" v-if="totalUserInfo.AddNum < 0"
                  >-{{ totalUserInfo.AddNum }}
                </span>
                <span v-if="!totalUserInfo.AddNum">-- </span>
                <img
                  v-if="totalUserInfo.AddNum > 0"
                  class="increaseIcon"
                  :src="increaseImg"
                  alt=""
                  srcset=""
                />
                <img
                  v-if="totalUserInfo.AddNum < 0"
                  class="decreaseIcon"
                  :src="decreaseImg"
                  alt=""
                  srcset=""
                />
                新增用户
              </div>
            </div>
            <div class="content-right">
              <img class="platformIcon" :src="totalUserImg" alt="" srcset="" />
            </div>
          </div>
        </div>
        <div class="item" style="background-color: #ffece8">
          <div class="detail-title">活跃用户</div>
          <div class="detail-content">
            <div class="content-left">
              <div class="detail-num">{{ activeUserInfo.Num }}</div>
              <div class="detail-text">
                <span style="color: #f53f3f" v-if="activeUserInfo.AddNum > 0"
                  >+{{ activeUserInfo.AddNum }}
                </span>
                <span style="color: #00b42a" v-if="activeUserInfo.AddNum < 0"
                  >-{{ activeUserInfo.AddNum }}
                </span>
                <span v-if="!activeUserInfo.AddNum">-- </span>
                <img
                  v-if="activeUserInfo.AddNum > 0"
                  class="increaseIcon"
                  :src="increaseImg"
                  alt=""
                  srcset=""
                />
                <img
                  v-if="activeUserInfo.AddNum < 0"
                  class="decreaseIcon"
                  :src="decreaseImg"
                  alt=""
                  srcset=""
                />
                新增用户
              </div>
            </div>
            <div class="content-right">
              <img class="platformIcon" :src="activeUserImg" alt="" srcset="" />
            </div>
          </div>
        </div>
        <div class="item" style="background-color: #f5e8ff">
          <div class="detail-title">
            {{ currentEnv.isZh ? "健康会员" : "VIP会员" }}
          </div>
          <div class="detail-content">
            <div class="content-left">
              <div class="detail-num">{{ healthMemberInfo.Num }}</div>
              <div class="detail-text">
                <span style="color: #f53f3f" v-if="healthMemberInfo.AddNum > 0"
                  >+{{ healthMemberInfo.AddNum }}
                </span>
                <span style="color: #00b42a" v-if="healthMemberInfo.AddNum < 0"
                  >-{{ healthMemberInfo.AddNum }}
                </span>
                <span v-if="!healthMemberInfo.AddNum">-- </span>
                <img
                  v-if="healthMemberInfo.AddNum > 0"
                  class="increaseIcon"
                  :src="increaseImg"
                  alt=""
                  srcset=""
                />
                <img
                  v-if="healthMemberInfo.AddNum < 0"
                  class="decreaseIcon"
                  :src="decreaseImg"
                  alt=""
                  srcset=""
                />
                新增会员
              </div>
            </div>
            <div class="content-right">
              <img
                class="platformIcon"
                :src="healthMemberImg"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </div>
        <div class="item" style="background-color: #e8f3ff">
          <div class="detail-title">总设备</div>
          <div class="detail-content">
            <div class="content-left">
              <div class="detail-num">{{ totalDevInfo.Num }}</div>
              <div class="detail-text">
                <span style="color: #f53f3f" v-if="totalDevInfo.AddNum > 0"
                  >+{{ totalDevInfo.AddNum }}
                </span>
                <span style="color: #00b42a" v-if="totalDevInfo.AddNum < 0"
                  >-{{ totalDevInfo.AddNum }}
                </span>
                <span v-if="!totalDevInfo.AddNum">-- </span>
                <img
                  v-if="totalDevInfo.AddNum > 0"
                  class="increaseIcon"
                  :src="increaseImg"
                  alt=""
                  srcset=""
                />
                <img
                  v-if="totalDevInfo.AddNum < 0"
                  class="decreaseIcon"
                  :src="decreaseImg"
                  alt=""
                  srcset=""
                />
                新增设备
              </div>
            </div>
            <div class="content-right">
              <img
                class="platformIcon"
                :src="totalEquipmentImg"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-content">
      <div class="map">
        <div class="title">全球设备分布图</div>
        <div class="echarts">
          <div id="map"></div>
        </div>
      </div>
      <div class="pie">
        <div class="title">用户画像</div>
        <div style="padding-left: 20px">
          <el-radio-group v-model="userRadio" @change="togglePie" size="small">
            <el-radio-button label="性别"></el-radio-button>
            <el-radio-button label="年龄"></el-radio-button>
            <el-radio-button label="使用终端"></el-radio-button>
            <el-radio-button label="已激活设备"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="content">
          <!-- <div class="title">按性别分布</div> -->
          <div class="echarts">
            <div id="pie-echarts"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div class="left">
          <span
            class="chart-title"
            :class="{ active: userType === 'newUser' }"
            @click="changeUserChart('newUser')"
            >新增用户</span
          >
          <span
            class="chart-title"
            :class="{ active: userType === 'activeUser' }"
            @click="changeUserChart('activeUser')"
            >活跃用户</span
          >
          <span
            class="chart-title"
            :class="{ active: userType === 'totalUser' }"
            @click="changeUserChart('totalUser')"
            >总用户</span
          >
        </div>
        <div class="right">
          <el-date-picker
            :clearable="false"
            @change="userChangefn"
            v-model="userDate"
            type="daterange"
            size="mini"
            :value-format="searchValFormat"
            :picker-options="pickerOptions"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="echarts">
        <div id="userEcharts"></div>
        <!-- <div v-if="userType === 'activeUser'" id="activeUserEcharts"></div> -->
        <!-- <div v-if="userType === 'totalUser'" id="totalUserEcharts"></div> -->
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div class="left">
          <span
            class="chart-title"
            :class="{ active: devType === 'newDev' }"
            @click="changeDevChart('newDev')"
            >新增设备</span
          >
          <span
            class="chart-title"
            :class="{ active: devType === 'activeDev' }"
            @click="changeDevChart('activeDev')"
            >活跃设备</span
          >
          <span
            class="chart-title"
            :class="{ active: devType === 'totalDev' }"
            @click="changeDevChart('totalDev')"
            >总设备</span
          >
        </div>
        <div class="right">
          <el-date-picker
            :clearable="false"
            v-model="devDate"
            type="daterange"
            size="mini"
            @change="devChangefn"
            :value-format="searchValFormat"
            :picker-options="pickerOptions"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="echarts">
        <div id="tatalDevEcharts"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  requestUserImportantMetrics,
  requestUserLineChartData,
  requestUserGroupData,
  requestuserFeedbackCount,
} from "@/api/userApi";
import { optionsList } from "@/api/optionsApi";
import { worldNameMap, worldGeoMap } from "@/assets/map/worldNameMap.js";
import { getDistribution } from "@/api/distribution.js";
import worldMapJson from "@/assets/map/world.json";
import { getYesterday, formatDate, env } from "@/utils/util";

export default {
  data() {
    return {
      currentEnv: env(),
      totalUserImg: require("@/assets/images/total user@2x.png"),
      activeUserImg: require("@/assets/images/active user@2x.png"),
      healthMemberImg: require("@/assets/images/healthmember@2x.png"),
      totalEquipmentImg: require("@/assets/images/total equipment@2x.png"),
      increaseImg: require("@/assets/images/increase@2x.png"),
      decreaseImg: require("@/assets/images/decrease@2x.png"),
      userRadio: "性别",
      userType: "newUser",
      userDate: null,
      devType: "newDev",
      devDate: null,
      value1: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      sexlist: [],
      agelist: [],
      devlist: [],
      deviceAccCount: null,
      devactlist: [],
      newUserXlist: [],
      newUserYlist: [],
      activeUserXlist: [],
      activeUserYlist: [],
      totalUserXlist: [],
      totalUserYlist: [],
      tatalDevXlist: [],
      tatalDevYlist: [],
      tatalDevDate: null,
      newUserDate: null,
      activeUserDate: null,
      totalUserDate: null,
      feedback: {},
      totalUserInfo: {},
      activeUserInfo: {},
      healthMemberInfo: {},
      totalDevInfo: {},
      worldNameMap,
      searchValFormat: "yyyy-MM-dd",
      worldGeoMap,
      mapdata: [],
      colorList: ["#62C4C7", "#B2A4DA", "#7AC1FA"],
    };
  },
  created() {
    this.value1 = getYesterday();
    this.getNameOptions();
    this.init();
  },
  mounted() {},
  methods: {
    // 获取所有下拉列表配置项
    async getNameOptions() {
      const { data } = await optionsList();
      if (data.code === 1000) {
        // 筛选商户类型
        const institutionType = data.data.list
          .filter((item) => item.type === 4)
          .map((item) => ({ label: item.name, value: item._id }));
        localStorage.setItem(
          "institutionType",
          JSON.stringify(institutionType)
        );
        // 筛选设备型号
        const deviceName = data.data.list
          .filter((item) => item.type === 1)
          .map((item) => ({ label: item.name, value: item._id }));
        localStorage.setItem("deviceName", JSON.stringify(deviceName));
        // 筛选设备类型
        const deviceType = data.data.list
          .filter((item) => item.type === 2)
          .map((item) => ({ label: item.name, value: item._id }));
        localStorage.setItem("deviceType", JSON.stringify(deviceType));
        // 筛选生产厂商
        const productName = data.data.list
          .filter((item) => item.type === 3)
          .map((item) => ({ label: item.name, value: item._id }));
        localStorage.setItem("productName", JSON.stringify(productName));
      }
    },
    // 切换用户画像
    togglePie(type) {
      // console.log(type);
      switch (type) {
        case "年龄":
          this.initEchartsTerminal();
          break;
        case "性别":
          this.initEchartsSex();
          break;
        case "使用终端":
          this.initEchartsDev();
          break;
        case "已激活设备":
          this.initEchartsDevActivate();
          break;
        default:
          break;
      }
    },
    changeUserChart(type) {
      this.userType = type;
      if (this.userType === "newUser") {
        this.newUserChangefn();
      }
      if (this.userType === "activeUser") {
        this.activeUserChangefn();
      }
      if (this.userType === "totalUser") {
        this.totalUserChangefn();
      }
      // console.log(this.userType);
    },
    changeDevChart(type) {
      this.devType = type;
      if (this.devType === "newDev") {
        this.newDevChangefn();
      }
      if (this.devType === "activeDev") {
        this.activeDevChangefn();
      }
      if (this.devType === "totalDev") {
        this.tatalDevChangefn();
      }
    },
    async requestuserFeedbackCountfn() {
      var res = await requestuserFeedbackCount();
      this.feedback = res.data.data.result;
    },
    async init() {
      this.initDate();
      // await this.requestuserFeedbackCountfn();
      await this.requestUserImportantMetricsfn();
      await this.requestUserGroupDatafn();
      await this.newUserfn();
      await this.activeUserfn();
      await this.totalUserfn();
      await this.newDevfn();
      var res = await getDistribution();
      this.mapdata = res.data.data.result;
      this.initData();
      this.initEchartsSex();
      this.initNewUserEcharts();
      this.initNewDevEcharts();
    },
    userChangefn() {
      if (this.userType === "newUser") {
        this.newUserChangefn();
      }
      if (this.userType === "activeUser") {
        this.activeUserChangefn();
      }
      if (this.userType === "totalUser") {
        this.totalUserChangefn();
      }
    },
    devChangefn() {
      if (this.devType === "newDev") {
        this.newDevChangefn();
      }
      if (this.devType === "activeDev") {
        this.activeDevChangefn();
      }
      if (this.devType === "totalDev") {
        this.tatalDevChangefn();
      }
    },
    async newUserfn() {
      if (this.userDate) {
        var start = this.userDate[0];
        var end = this.userDate[1];
      } else {
        var start = "";
        var end = "";
      }

      var res = await requestUserLineChartData({
        type: 1,
        start,
        end,
      });
      this.newUserXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.newUserYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
    },
    async activeUserfn() {
      if (this.userDate) {
        var start = this.userDate[0];
        var end = this.userDate[1];
      } else {
        var start = "";
        var end = "";
      }

      var res = await requestUserLineChartData({
        type: 2,
        start,
        end,
      });
      this.activeUserXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.activeUserYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
    },
    async totalUserfn() {
      if (this.userDate) {
        var start = this.userDate[0];
        var end = this.userDate[1];
      } else {
        var start = "";
        var end = "";
      }

      var res = await requestUserLineChartData({
        type: 4,
        start,
        end,
      });

      this.totalUserXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.totalUserYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
      //  console.log(res.data.data.result);
    },
    async newDevfn() {
      if (this.devDate) {
        var start = this.devDate[0];
        var end = this.devDate[1];
      } else {
        var start = "";
        var end = "";
      }
      var res = await requestUserLineChartData({
        type: 3,
        start,
        end,
      });
      this.tatalDevXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.tatalDevYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
    },
    async activeDevfn() {
      if (this.devDate) {
        var start = this.devDate[0];
        var end = this.devDate[1];
      } else {
        var start = "";
        var end = "";
      }
      var res = await requestUserLineChartData({
        type: 7,
        start,
        end,
      });
      this.tatalDevXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.tatalDevYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
    },
    async tatalDevfn() {
      if (this.devDate) {
        var start = this.devDate[0];
        var end = this.devDate[1];
      } else {
        var start = "";
        var end = "";
      }
      var res = await requestUserLineChartData({
        type: 5,
        start,
        end,
      });
      this.tatalDevXlist = res.data.data.result.map((item) => {
        return item.Day.slice(0, 10);
      });
      this.tatalDevYlist = res.data.data.result.map((item) => {
        return item.Num;
      });
    },
    async requestUserGroupDatafn() {
      const { data } = await requestUserGroupData();
      const gender = data.data.result.gender;
      const deviceUser = data.data.result.deviceUser;
      const age = data.data.result.age;
      const userSource = data.data.result.userSource;
      // console.log('gender',gender);
      // console.log('deviceUser',deviceUser);
      // console.log('age',age);
      // console.log('userSource',userSource);
      this.sexlist = gender.map((item) => {
        let name;
        let value = item.Total;

        if (item.Gender == 0) {
          name = "男";
        } else if (item.Gender == 1) {
          name = "女";
        } else {
          name = "未知";
        }
        return {
          value,
          name,
        };
      });
      if (this.sexlist[0]?.name == "未知") {
        this.sexlist.push(this.sexlist.shift());
      }
      this.agelist = age.map((item) => {
        var name;
        var value = item.Count;
        if (item.AgeGroup == "") {
          name = "未知";
        } else {
          name = item.AgeGroup;
        }
        return {
          name,
          value,
        };
      });
      if (this.agelist[0]?.name == "未知") {
        this.agelist.push(this.agelist.shift());
      }
      this.devlist = userSource.map((item) => {
        var name = item.Name ? item.Name : "未知";
        var value = item.Count;
        return {
          name,
          value,
        };
      });
      if (this.devlist[0]?.name == "未知") {
        this.devlist.push(this.devlist.shift());
      }
      this.devactlist = deviceUser.map((item) => {
        var name = item.Name ? item.Name : "未知";
        var value = item.Count;
        return {
          name,
          value,
        };
      });
      if (this.devactlist[0]?.name == "未知") {
        this.devactlist.push(this.devactlist.shift());
      }
    },
    async requestUserImportantMetricsfn() {
      const { data } = await requestUserImportantMetrics({
        timeRange: this.value1,
      });
      if (data.code === 1000) {
        data.data.result.forEach((item) => {
          if (item.Type === 4) this.totalUserInfo = item;
          if (item.Type === 2) this.activeUserInfo = item;
          if (item.Type === 6 && this.currentEnv.isZh)
            this.healthMemberInfo = item;
          if (item.Type === 8 && !this.currentEnv.isZh)
            this.healthMemberInfo = item;
          if (item.Type === 5) this.totalDevInfo = item;
        });
      } else {
        this.$message.error(data.msg);
      }
    },
    initDate() {
      const today = new Date();
      const endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      var startDate = new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate() - 7
      );
      const start = formatDate(startDate, "YYYY-MM-DD");
      const end = formatDate(endDate, "YYYY-MM-DD");
      // var end =
      //   endDate.getFullYear() +
      //   "-" +
      //   (endDate.getMonth() + 1) +
      //   "-" +
      //   endDate.getDate();
      // var start =
      //   startDate.getFullYear() +
      //   "-" +
      //   (startDate.getMonth() + 1) +
      //   "-" +
      //   startDate.getDate();
      var datelist = [start, end];
      this.userDate =
        this.devDate =
        this.tatalDevDate =
        this.newUserDate =
        this.activeUserDate =
        this.totalUserDate =
          datelist;
    },
    async newUserChangefn() {
      await this.newUserfn();
      this.initNewUserEcharts();
    },
    async activeUserChangefn() {
      await this.activeUserfn();
      this.initActiveUserEcharts();
    },
    async totalUserChangefn() {
      await this.totalUserfn();
      this.initTotalUserEcharts();
    },
    async newDevChangefn() {
      await this.newDevfn();
      this.initNewDevEcharts();
    },
    async activeDevChangefn() {
      await this.activeDevfn();
      this.initActiveDevEcharts();
    },
    async tatalDevChangefn() {
      await this.tatalDevfn();
      this.initTatalDevEcharts();
    },
    initNewDevEcharts() {
      var chartDom = document.getElementById("tatalDevEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.tatalDevXlist,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          splitNumber: 5,
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "新增设备数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.tatalDevYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initActiveDevEcharts() {
      var chartDom = document.getElementById("tatalDevEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        // color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.tatalDevXlist,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "活跃设备数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.tatalDevYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initTatalDevEcharts() {
      var chartDom = document.getElementById("tatalDevEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.tatalDevXlist,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "累计设备数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.tatalDevYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initTotalUserEcharts() {
      var chartDom = document.getElementById("userEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.totalUserXlist,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "累计用户数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.totalUserYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initActiveUserEcharts() {
      var chartDom = document.getElementById("userEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.activeUserXlist,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "活跃用户数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.activeUserYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initNewUserEcharts() {
      var chartDom = document.getElementById("userEcharts");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: this.colorList,
        legend: {
          left: "center",
          bottom: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.newUserXlist,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        series: [
          {
            name: "新增用户数",
            type: "line",
            smooth: true,
            stack: "Total",
            data: this.newUserYlist,
            itemStyle: {
              color: "#2599FF",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(17, 126, 255, 0.16)",
                },
                {
                  offset: 1,
                  color: "rgba(17, 128, 255, 0)",
                },
              ]),
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initEchartsDevActivate() {
      var chartDom = document.getElementById("pie-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        // color: this.colorList,
        tooltip: {
          trigger: "item",
        },
        legend: {
          // top: "5%",
          left: "center",
          bottom: "5%",
        },
        series: [
          {
            name: "详细信息",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.devactlist,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    initEchartsDev() {
      var chartDom = document.getElementById("pie-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        // color: this.colorList,
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: 0,
          right: 25,
          top: 0,
          bottom: 0,
          containLabel: true,
        },
        legend: {
          //   top: "5%",
          left: "center",
          bottom: "5%",
        },
        series: [
          {
            name: "详细信息",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.devlist,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initEchartsTerminal() {
      var chartDom = document.getElementById("pie-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        // color: this.colorList,
        tooltip: {
          trigger: "item",
        },
        legend: {
          //   top: "5%",
          left: "center",
          bottom: "5%",
        },
        series: [
          {
            name: "详细信息",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.agelist,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initEchartsSex() {
      var chartDom = document.getElementById("pie-echarts");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        // color: this.colorList,
        tooltip: {
          trigger: "item",
        },
        legend: {
          //   top: "5%",
          left: "center",
          bottom: "5%",
        },
        series: [
          {
            name: "详细信息",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "40%"],
            top: 0,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "outside",
              formatter: "{b}: {c} ({d}%)",
            },
            emphasis: {
              label: {
                show: false,
                // fontSize: "40",
                // fontWeight: "bold"
              },
            },
            labelLine: {
              show: false,
            },
            data: this.sexlist,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initData() {
      var map = document.querySelector("#map");
      let chartDom = echarts.init(map);
      var max = 0;
      let riskData = this.mapdata.map((item) => {
        if (item.CnName == "" && item.EnName == "") {
          return {
            name: "",
            value: "",
          };
        } else {
          if (item.Total > max) {
            max = item.Total;
          }

          return {
            name: item.CnName,
            value: item.Total,
          };
        }
      });

      // console.log(max);
      var flag = true;
      var flag1 = true;
      var m = 1;
      var mul = 1;
      while (flag) {
        var mm = Math.pow(10, m);
        if (max <= 5 * mm) {
          while (flag1) {
            var mm = Math.pow(10, m - 1);
            if (max < 5 * mul * mm) {
              flag1 = false;
              max = 5 * mul * mm;
            }
            mul++;
          }

          flag = false;
        }
        m++;
      }
      var step = max / 5;
      var pieces = [];
      for (var i = 0; i < 5; i++) {
        pieces[i] = {
          min: i * step,
          max: (i + 1) * step,
          color: "rgba(22, 93, 255," + (i + 1) * 0.2 + ")",
        };
      }
      let markPointData = [
        {
          name: "中国",
          coord: this.worldGeoMap["中国"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
        {
          name: "澳大利亚",
          coord: this.worldGeoMap["澳大利亚"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
        {
          name: "加拿大",
          coord: this.worldGeoMap["加拿大"],
          //   symbol: "image://" + icon,
          symbolSize: 20,
        },
      ];
      echarts.registerMap("world", worldMapJson);
      let option = {
        // left:"5%",
        // right:"5%",
        // top:"5%",
        // bottom:"5%",
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
          },
          borderWidth: 2,
          borderColor: "#ECECEE",
          padding: 10,
          formatter: function (params) {
            var value = params.value ? params.value : 0;
            return "分布情况<br/>" + params.name + " : " + value + "个";
          },
        },
        // legend: {
        //   show: true,
        //   top: 'bottom'
        // },
        visualMap: {
          // show: false,
          type: "piecewise",
          orient: "horizontal",
          splitNumber: 3,
          inverse: true,
          origin: "",
          right: "center",
          bottom: 0,
          pieces,
          textStyle: {
            color: "#6E7784",
          },
          itemWidth: 40,
          itemHeight: 10,
          align: "left",
        },
        series: [
          {
            type: "map",
            map: "world",
            nameMap: this.worldNameMap,
            roam: false,
            itemStyle: {
              areaColor: "#E8F3FF",
              borderWidth: 0,
              emphasis: {
                label: {
                  show: false,
                },
                areaColor: "#feddb3",
              },
            },
            left: "15%",
            right: "15%",
            top: "2%",
            bottom: "10%",
            data: riskData,
          },
        ],
      };
      chartDom && chartDom.setOption(option);
      let sizeFun = () => {
        chartDom.resize();
      };
      window.addEventListener("resize", sizeFun);
      this.$once("hook:beforeDestroy", function () {
        echarts.dispose(chartDom);
      });
    },
  },
};
</script>

<style lang="less">
.home {
  background-color: #f3f3f3;
  overflow-y: auto;
  .feedback {
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 40px;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    p {
      margin: 0;
      font-weight: 500;
    }
    .red {
      color: red;
    }
    a {
      height: auto;
    }
  }
  .content-group {
    display: flex;
    .content {
      flex: 1;
      &:nth-of-type(1) {
        margin-right: 10px;
      }
      &:nth-of-type(2) {
        margin-left: 10px;
      }
    }
  }
  .content {
    border-radius: 10px;
    overflow: hidden;
    margin-top: 16px;
    .echarts {
      background-color: #fff;
      .datePicker {
        display: flex;
        padding: 20px;
        align-items: center;
        // span {
        // font-weight: 600;
        // }
      }
      #map {
        width: 100%;
        height: 40vh;
      }
      #userEcharts,
      #newUserEcharts,
      #activeUserEcharts,
      #totalUserEcharts,
      #tatalDevEcharts {
        width: 100%;
        height: 35vh;
      }
    }
    .title {
      background-color: #fff;
      padding: 15px 20px;
      color: #333;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      font-family: pf, sans-serif;
      font-weight: 400;
      color: #1d2129;
      font-size: 16px;
      margin: 0;
      .chart-title {
        margin-right: 20px;
        color: #4e5969;
        cursor: pointer;
      }
      .active {
        color: #165dff;
        font-family: pfc, sans-serif;
        font-weight: 500;
        padding-bottom: 10px;
        border-bottom: 3px solid #165dff;
      }
    }
    .detail {
      display: flex;
      align-items: center;
      // text-align: center;
      justify-content: space-between;
      background-color: #fff;
      padding: 0 20px 20px;

      .item {
        // width: 20%;
        flex: 1;
        padding: 20px;
        margin-right: 16px;
        border-radius: 10px;
        background-color: #03f9e564;
        .detail-title {
          font-size: 16px;
          font-family: pfc, sans-serif;
          font-weight: 500;
          color: #1d2129;
          padding-bottom: 20px;
        }
        .detail-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .platformIcon {
            width: 54px;
            height: 54px;
          }
        }
        .detail-num {
          font-size: 24px;
          font-family: pfc, sans-serif;
          font-weight: 500;
          // text-align: center;
          padding-bottom: 4px;
        }
        .detail-text {
          font-family: pf, sans-serif;
          font-size: 16px;
        }
        .increaseIcon,
        .decreaseIcon {
          width: 12px;
          height: 12px;
          cursor: pointer;
        }
        .detail-type {
          color: #f53f3f;
        }
      }
      .item:last-child {
        margin-right: 0;
      }
    }
  }
  .map-content {
    width: 100%;
    display: flex;
    // border-radius: 10px;
    overflow: hidden;
    margin-top: 16px;
    .map {
      width: 60%;
      background-color: #fff;
      margin-right: 16px;
      border-radius: 10px;
    }
    .pie {
      width: 40%;
      background-color: #fff;
      border-radius: 10px;
    }
    .echarts {
      // background-color: #fff;
      #map {
        width: 100%;
        height: 330px;
      }
      #pie-echarts,
      #echartsTerminal,
      #echartsDev,
      #echartsDevActivate {
        width: 100%;
        height: 300px;
        margin: 0 auto;
      }
    }
    .title {
      // background-color: #fff;
      font-family: pfc, sans-serif;
      font-weight: 500;
      padding: 25px 20px;
      color: #333;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      font-size: 16px;
      margin: 0;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #165dff;
    }
  }
}
</style>
